interface ConfigProps {
  AUTHORITY: string;
  CLIENT_ID: string;
  REDIRECT_URI: string;
  RESPONSE_TYPE: string;
  AUTHORIZATION_URI: string;
  END_SESSION_URI: string;
  SCOPE: string;
}

const config: ConfigProps = {
  AUTHORITY: 'http://accessdev.scg.co.th',
  CLIENT_ID: 'BACKSPACE-USER-SYSTEM-DEV',
  REDIRECT_URI: `${window.location.origin}${process.env.PUBLIC_URL}`,
  RESPONSE_TYPE: 'code',
  AUTHORIZATION_URI: 'https://accessdev.scg.co.th/adfs/oauth2/authorize',
  END_SESSION_URI: 'https://accessdev.scg.co.th/adfs/ls/?wa=wsignout1.0',
  SCOPE: 'openid'
};

export default config;
